import { render, staticRenderFns } from "./SchoolClass.vue?vue&type=template&id=f8a23688"
import script from "./SchoolClass.vue?vue&type=script&lang=js"
export * from "./SchoolClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports